import { createSlice } from "@reduxjs/toolkit";
import { resetCurrentAccount, setCurrentAccount } from "../current-account/current-account";
var initialState = {
    accountId: undefined,
    bypassAuthentication: Boolean(import.meta.env.VITE_BYPASS_AUTH)
};
export var authMiddleware = function(store) {
    return function(next) {
        return function(action) {
            if (authSlice.actions.setAccountId.match(action)) {
                if (action.payload) {
                    var accounts = store.getState().accounts.accounts;
                    var account = accounts.find(function(param) {
                        var key = param.key;
                        return key === action.payload;
                    });
                    if (account) {
                        var _store_getState_auth_accountId, _ref;
                        var currentAccountId = (_ref = (_store_getState_auth_accountId = store.getState().auth.accountId) !== null && _store_getState_auth_accountId !== void 0 ? _store_getState_auth_accountId : localStorage.getItem("vch.account_id")) !== null && _ref !== void 0 ? _ref : undefined;
                        // Reset all account state immediately when the account changes so the
                        // incoming account never inherits the previous account's permissions,
                        // tier, or usage until fresh data arrives.
                        if (currentAccountId && currentAccountId !== account.key) {
                            store.dispatch(resetCurrentAccount());
                            store.dispatch(setCurrentAccount({
                                isPostpaid: account.postpaid
                            }));
                        }
                        localStorage.setItem("vch.account_id", action.payload);
                    } else if (accounts.length > 0) {
                        action.payload = accounts[0].key;
                        store.dispatch(resetCurrentAccount());
                        store.dispatch(setCurrentAccount({
                            isPostpaid: accounts[0].postpaid
                        }));
                        localStorage.setItem("vch.account_id", accounts[0].key);
                    } else {
                        localStorage.setItem("vch.account_id", action.payload);
                    }
                } else {
                    localStorage.removeItem("vch.account_id");
                }
            }
            return next(action);
        };
    };
};
var authSlice = createSlice({
    initialState: initialState,
    name: "auth",
    reducers: {
        setAccountId: function(state, param) {
            var payload = param.payload;
            state.accountId = payload;
        },
        setBypassAuthentication: function(state, param) {
            var payload = param.payload;
            state.bypassAuthentication = payload;
        }
    }
});
var _authSlice_actions = authSlice.actions;
export var setAccountId = _authSlice_actions.setAccountId, setBypassAuthentication = _authSlice_actions.setBypassAuthentication;
export var authReducer = authSlice.reducer;

//# sourceMappingURL=auth.js.map